
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class CrayonProductModel extends Model<CrayonProductModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'number', isHidden: true },
		{ name: 'productName', type: 'string' },
		{ name: 'partNumber', type: 'string' },
		{ name: 'productFamilyName', type: 'string' },
		{ name: 'defaultBillingCycleId', type: 'number' },
		{ name: 'purchasePeriod', type: 'string' }
	];
	[key: string]: any;
	
	public id: number;
	public productName: string;
	public partNumber: string;
	public productFamilyName: string;
	public defaultBillingCycleId: number;
	public purchasePeriod: string;
    
	constructor(){
		super();
		this.id = 0;
		this.productName = '';
		this.partNumber = '';
		this.productFamilyName = '';
		this.defaultBillingCycleId = 0;
		this.purchasePeriod = '';
		
	}
	getProperties(){
		return CrayonProductModel.classProperties;
	}
}

